import request from 'local_modules/request'
import { constants } from 'helpers'
import { reducers, getState } from 'redux/core'
// import actions from 'redux/actions'

const getModalTitle = data => {
  const isUpdated = data && (data.updated || data.created || data.deleted)
  return isUpdated ? 'Данные обновлены' : 'Ошибка'
}

const setFetching = (isFetching) => reducers.marketplace.adminScheduleConfigPage.setFetching(isFetching)

const fetchLabels = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.tariffLabels + `/${tool}`)
    .then(({ data }) => data)
    .then((data) => {
      reducers.marketplace.adminScheduleConfigPage.setLabels(data)

      return Promise.all(data.map(({ id }) => fetchSessionsByLabel(id)))
    })
}

const fetchSessions = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.tariffSessions + `/${tool}`)
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminScheduleConfigPage.setSessions(data))
}

const setLabels = (labels) => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.post(constants.marketplace.tariffLabels + `/${tool}`, labels.map(({ id, lbl, active }) => ({ id, lbl, active })))
    .then(({ data }) => data)
    .then((data) => {
        if (!Object.keys(data).length) return null
        const title = getModalTitle(data)
        return { title, text: data['error'] || '' }
    })
}

const setSessions = (sessions) => {
  const { marketplace: { layersNavigation: { tool } } } = getState()
  console.log('in setSessions', {sessions})
  return request.post(
    constants.marketplace.tariffSessions + `/${tool}`,
    sessions.map(({ id, start, finish, active }) => ({
      id,
      startInt: {
        h: Number(start.slice(0, 2)),
        m: Number(start.replace(/:/,'').slice(2, 4)),
      },
      finishInt: {
        h: Number(finish.slice(0, 2)),
        m: Number(finish.replace(/:/,'').slice(2, 4)),
      },
      active
    }))
  )
    .then(({ data }) => data)
    .then((data) => {
      if (!Object.keys(data).length) return null
      const title = getModalTitle(data)
      return { title, text: data['error'] || '' }
    })
}

const updateSessionsByLabel = ({ labelId, sessions }) => {
  return request.post(constants.marketplace.sessionsByLabel + `/${labelId}`, sessions)
    .then(({ data }) => data)
    .then((data) => {
      if (!Object.keys(data).length) return null
      const title = getModalTitle(data)
      return { title, text: data['error'] || '' }
    })
}

const fetchSessionsByLabel = (labelId) => {
  return request.get(constants.marketplace.sessionsByLabel + `/${labelId}`)
    .then(({ data }) => data)
    .then((sessions) => reducers.marketplace.adminScheduleConfigPage.setLabelSessions({ id: labelId, sessions }))
    .catch((error) => console.log(error))
}

const fetchParams = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.environmentTool + `/${tool}`)
    .then(({ data }) => data)
    .then((params) => {
      reducers.marketplace.adminScheduleConfigPage.setParams(params)
    })
}

const setParams = ({ toolId, capacity, closeTime, editTime, withNumbers }) => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.post(constants.marketplace.environmentTool, { id: tool, capacity, closeTime, editTime, withNumbers })
    .then(({ data }) => data)
    .then((data) => {
      if (!Object.keys(data).length) return null
      const title = getModalTitle(data)
      return { title, text: data['error'] || '' }
    })
}


export default {
  setFetching,

  fetchLabels,
  fetchSessions,
  fetchParams,

  setLabels,
  setSessions,
  setParams,

  updateSessionsByLabel,
}
